import { LOCATION_CHANGE } from 'react-router-redux';
import { handleActions } from 'redux-actions';
import { mapReducersFromConfigurations } from '../../helpers/reducer';
import { configurations } from './configurations';

export const initialState = {
  recommendedResult: [],
  searchTileResult: {
    content: [],
    events: [],
    searchTiles: [],
    total: 0,
    hits: undefined,
    take: 0,
    skip: 0
  },
  isFetching: false,
  isLoadingMore: false,
  error: null
};

const reducer = handleActions({
  ...mapReducersFromConfigurations('searchTile')(configurations),
  [LOCATION_CHANGE]: (state, action) => {
    return Object.assign(state, initialState);
  }
}, {
    ...initialState
  });

export default reducer;



// WEBPACK FOOTER //
// ./src/state/modules/search-tile/reducers.js